import { environment } from '../../environments/environment';

export const APP_BRAND = environment.brand;
